import { Logo, LogoText } from "@/components/ui/Logo";
import { Link } from "react-router-dom";
import { Mail, Phone, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
export const LandingFooter = () => {
  return <footer className="bg-midnight-green text-ivory py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Column 1: Logo & Tagline */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center cursor-pointer">
              <Logo variant="horizontal" size="md" className="brightness-0 invert" />
            </Link>
            <p className="font-inter text-ivory/80 text-sm leading-relaxed">
              Pro-Level Kitchen Command for outdoor culinary professionals
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-ivory/60 hover:text-copper transition-colors" aria-label="Follow us on Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-ivory/60 hover:text-copper transition-colors" aria-label="Follow us on Twitter">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-ivory/60 hover:text-copper transition-colors" aria-label="Follow us on Instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-ivory/60 hover:text-copper transition-colors" aria-label="Follow us on LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Column 2: Navigation */}
          <div>
            <h3 className="font-playfair text-lg font-semibold mb-4 text-copper">Product</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/#features" className="font-inter text-ivory/80 hover:text-copper transition-colors text-sm">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/#how-it-works" className="font-inter text-ivory/80 hover:text-copper transition-colors text-sm">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/use-cases" className="font-inter text-ivory/80 hover:text-copper transition-colors text-sm">
                  Use Cases
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="font-inter text-ivory/80 hover:text-copper transition-colors text-sm">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Company */}
          <div>
            <h3 className="font-playfair text-lg font-semibold mb-4 text-copper">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="font-inter text-ivory/80 hover:text-copper transition-colors text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="font-inter text-ivory/80 hover:text-copper transition-colors text-sm">
                  Contact
                </Link>
              </li>
              
              <li>
                <a href="#" className="font-inter text-ivory/80 hover:text-copper transition-colors text-sm">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact & Newsletter */}
          <div>
            <h3 className="font-playfair text-lg font-semibold mb-4 text-copper">Get in Touch</h3>
            <ul className="space-y-3 mb-6">
              
              
            </ul>
            
            {/* Newsletter */}
            <div>
              <p className="font-inter text-ivory/80 text-sm mb-3">
                Stay updated on camp kitchen best practices
              </p>
              <div className="flex gap-2">
                <input type="email" placeholder="Your email" className="flex-1 px-3 py-2 rounded-md bg-white/10 border border-ivory/20 text-ivory text-sm placeholder:text-ivory/50 focus:outline-none focus:ring-2 focus:ring-copper" />
                <button className="px-4 py-2 bg-copper hover:bg-copper/90 rounded-md text-ivory font-semibold text-sm transition-colors">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-ivory/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-inter text-ivory/60 text-sm">
              © 2025 CampChef Pro. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="font-inter text-ivory/60 hover:text-copper text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="font-inter text-ivory/60 hover:text-copper text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="/security" className="font-inter text-ivory/60 hover:text-copper text-sm transition-colors">
                Security
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};